var $ = require('jquery');

module.exports = function () {
    var holidayDates = null;
    var currDate = new Date();
    var currYear = currDate.getFullYear();
    var currMoth = currDate.getMonth();
    var isShowHoliday = false;

    var lunarInfo = new Array(
        0x04bd8, 0x04ae0, 0x0a570, 0x054d5, 0x0d260, 0x0d950, 0x16554, 0x056a0, 0x09ad0, 0x055d2,
        0x04ae0, 0x0a5b6, 0x0a4d0, 0x0d250, 0x1d255, 0x0b540, 0x0d6a0, 0x0ada2, 0x095b0, 0x14977,
        0x04970, 0x0a4b0, 0x0b4b5, 0x06a50, 0x06d40, 0x1ab54, 0x02b60, 0x09570, 0x052f2, 0x04970,
        0x06566, 0x0d4a0, 0x0ea50, 0x06e95, 0x05ad0, 0x02b60, 0x186e3, 0x092e0, 0x1c8d7, 0x0c950,
        0x0d4a0, 0x1d8a6, 0x0b550, 0x056a0, 0x1a5b4, 0x025d0, 0x092d0, 0x0d2b2, 0x0a950, 0x0b557,
        0x06ca0, 0x0b550, 0x15355, 0x04da0, 0x0a5d0, 0x14573, 0x052d0, 0x0a9a8, 0x0e950, 0x06aa0,
        0x0aea6, 0x0ab50, 0x04b60, 0x0aae4, 0x0a570, 0x05260, 0x0f263, 0x0d950, 0x05b57, 0x056a0,
        0x096d0, 0x04dd5, 0x04ad0, 0x0a4d0, 0x0d4d4, 0x0d250, 0x0d558, 0x0b540, 0x0b5a0, 0x195a6,
        0x095b0, 0x049b0, 0x0a974, 0x0a4b0, 0x0b27a, 0x06a50, 0x06d40, 0x0af46, 0x0ab60, 0x09570,
        0x04af5, 0x04970, 0x064b0, 0x074a3, 0x0ea50, 0x06b58, 0x055c0, 0x0ab60, 0x096d5, 0x092e0,
        0x0c960, 0x0d954, 0x0d4a0, 0x0da50, 0x07552, 0x056a0, 0x0abb7, 0x025d0, 0x092d0, 0x0cab5,
        0x0a950, 0x0b4a0, 0x0baa4, 0x0ad50, 0x055d9, 0x04ba0, 0x0a5b0, 0x15176, 0x052b0, 0x0a930,
        0x07954, 0x06aa0, 0x0ad50, 0x05b52, 0x04b60, 0x0a6e6, 0x0a4e0, 0x0d260, 0x0ea65, 0x0d530,
        0x05aa0, 0x076a3, 0x096d0, 0x04bd7, 0x04ad0, 0x0a4d0, 0x1d0b6, 0x0d250, 0x0d520, 0x0dd45,
        0x0b5a0, 0x056d0, 0x055b2, 0x049b0, 0x0a577, 0x0a4b0, 0x0aa50, 0x1b255, 0x06d20, 0x0ada0);
//国历节日 *表示放假日
    var sFtv = new Array(
        "0101 元旦",
        "0214 情人",
        "0312 植树",
        "0404 清明",
        "0501 五一",
        "0601 六一",
        "1001 国庆",
        "1225 圣诞");

//农历节日 *表示放假日
    var lFtv = new Array(
        "0101 春节",
        "0115 元宵",
        "0505 端午",
        "0707 七夕",
        "0815 中秋",
        "0909 重阳");

    /**
     *  填写日历表格的节假日
     * @param container  当一个界面上存在2种日历显示，一种点击弹出显示，一种平面显示【平面显示日历会放在一个div里】，平面显示的日历请传container 包含的div
     * @param isShowHoliday  节假日时 是否展示 休 班
     */
    function setHoliday(container,isShowHoliday) {
        var $document = $(container + '>iframe[hideFocus="true"]').contents();
        var $WdayTable = $document.find('.WdayTable');
        if ($WdayTable.length == 0) {
            var inter = setInterval(function () {
                $WdayTable = $document.find('.WdayTable');
                if ($WdayTable.length > 0) {
                    setFestival($WdayTable);
                    clearInterval(inter);
                }
            }, 100)
        } else {
            setFestival($WdayTable);
        }
    };

    //填写日历的节假日
    function setFestival($WdayTable) {
        $WdayTable.find('td[onclick]').each(function () {
            var onclickStr = $(this).attr('onclick');
            var dateStr = onclickStr.substring(onclickStr.indexOf('(') + 1, onclickStr.indexOf(')'));
            var tdDate = new Date(dateStr);
            var tdYear = tdDate.getFullYear();
            var tdMoth = tdDate.getMonth();
            var festival = getFestival(tdDate);
            //只有当前年(当前前一年的12月份)才显示 班 或 休
            if (tdYear === currYear || (tdYear + 1 === currYear && tdMoth + 1 === 12)) {
                if(isShowHoliday && holidayDates) {
                    var restOrWork = getRestOrWork(tdDate);
                    restOrWork.text && $(this).html(restOrWork.text);
                    restOrWork.isRest && $(this).attr('rest', true);
                }
            }
            if(festival) {
                $(this).html(festival);//当又是休息，又是节日时，优先展示节日
                $(this).attr('festival', true);
            }
        });

        //如果又是节日又是休息日，往前往后有连续的休息日时，显示休
        $WdayTable.find('[rest="true"][festival="true"]').each(function () {
            var $rests = [];
            searchPre($(this),$rests);
            searchAfter($(this),$rests);
            if($rests.length >= 2){//只有连续是3天休息的节假日的休息才显示休 比如六一是周六，之后的周日就不要显示休
                $rests.forEach(function (item) {
                    $(item).html('休');
                });
            }
        });
        //往前查找
        function searchPre($festival,$rests,isDoubleMonth) {
            $prev =  $festival.prev('td[onclick]');
            if($prev.length === 0){
                $prev = $festival.parent().prev().find('td[onclick]:last-child');
            }
            if($prev.length === 0 && isDoubleMonth){//如果是双月，查看前面是否还有表格继续查找
                var $prevTable = $festival.parents('table.WdayTable').parent().prev().find('.WdayTable');
                if($prevTable.length > 0){
                    $prev = $prevTable.find('tr:last-child').find('td[onclick]').last();
                }
            }
            if($prev.length>0){
                if($prev.attr('rest')) {
                    !$prev.attr('festival') && $rests.push($prev);//只有不是节日是休息才显示休
                    searchPre($prev,$rests);
                }
            }
        }
        //往后查找
        function searchAfter($festival,$rests,isDoubleMonth) {
            $next =  $festival.next('td[onclick]');
            if($next.length === 0){
                $next = $festival.parent().next().find('td[onclick]:first-child');
            }
            if($next.length === 0 && isDoubleMonth){//如果是双月，查看后面是否还有表格继续查找
                var $nextTable = $festival.parents('table.WdayTable').parent().next().find('.WdayTable');
                if($nextTable.length > 0){
                    $next = $nextTable.find('tr:not(.MTitle)').first().find('td[onclick]').first();
                }
            }
            if($next.length>0){
                if($next.attr('rest')) {
                    !$next.attr('festival') && $rests.push($next);//只有不是节日是休息才显示休
                    searchAfter($next,$rests);
                }
            }
        }
    }

    //根据日期获取显示 ‘休’ 或 ‘班’  不是返空
    function getRestOrWork(date) {
        var ym;
        var m = (date.getMonth() + 1).toString();
        var d = date.getDate().toString();
        var day = date.getDay();
        ym = date.getFullYear().toString() + (m.length === 1 ? '0' + m : m);
        d = d.length === 1 ? '0' + d : d;
        var isRest = !!(holidayDates && holidayDates[ym] && holidayDates[ym][d]);//holidayDates有值说明是休息
        var text = '';
        //如果当前是休息日  却是上班日  则应显示休
        if (isRest && day >= 1 && day <= 5) {
            text = '休';
        }
        //如果当前不是休息日  却是周未  则应显示班
        else if (!isRest && (day === 0 || day === 6)) {
            text = '班';
        }
        return {text:text,isRest:isRest};
    }

    //获取清明节在当年的日期
    function getQinMingJieDate(year) {
        //清明节的日期是不固定的，规律是：闰年开始的前2年是4月4日，闰年开始的第3年和第4年是4月5日
        if (isLeapYear(year) || isLeapYear(year - 1)) {
            return '0404';
        } else {
            return '0405';
        }
    }

    //判断是否是闰年
    function isLeapYear(Year) {
        if (((Year % 4) == 0) && ((Year % 100) != 0) || ((Year % 400) == 0)) {
            return (true);
        } else {
            return (false);
        }
    }

    //根据日期获取节日名称 不是节日返空
    function getFestival(date) {
        var result = "";
        var _year = Number(date.getFullYear());
        var _month = Number(date.getMonth());
        var _date = Number(date.getDate());
        sFtv[3] = getQinMingJieDate(_year) + ' 清明';
        for (var i in sFtv) {
            if (sFtv[i].match(/^(\d{2})(\d{2})(\s)(.+)$/)) {
                if (Number(RegExp.$1) == (_month + 1) && Number(RegExp.$2) == _date) {
                    result = RegExp.$4;
                }
            }
        }
        var ldate = new Lunar(date);
        //农历
        _month = Number(ldate.month);
        _date = parseInt(ldate.day);
        for (i in lFtv) {
            if (lFtv[i].match(/^(\d{2})(.{2})([\s])(.+)$/)) {
                if (Number(RegExp.$1) == _month && Number(RegExp.$2) == _date) {
                    result = RegExp.$4;
                }
            }
        }
        var llastdate = ldate.isLeap ? leapDays(ldate.year) : monthDays(ldate.year, ldate.month);
        if (_month == 12 && _date == llastdate) {
            result = "除夕";
        }
        return result;
    }

    //====================================== 传回农历 y年闰月的天数
    function leapDays(y) {
        if (leapMonth(y))
            return ((lunarInfo[y - 1900] & 0x10000) ? 30 : 29);
        else
            return (0);
    }

    //====================================== 传回农历 y年闰哪个月 1-12 , 没闰传回 0
    function leapMonth(y) {
        return (lunarInfo[y - 1900] & 0xf);
    }

    //====================================== 传回农历 y年的总天数
    function lYearDays(y) {
        var i, sum = 348;
        for (i = 0x8000; i > 0x8; i >>= 1) {
            sum += (lunarInfo[y - 1900] & i) ? 1 : 0;
        }
        return (sum + leapDays(y));
    }

    //====================================== 传回农历 y年m月的总天数
    function monthDays(y, m) {
        return ((lunarInfo[y - 1900] & (0x10000 >> m)) ? 30 : 29);
    }

    //====================================== 算出农历
    // 该物件属性有 .year .month .day .isLeap .yearCyl .dayCyl .monCyl
    function Lunar(objDate) {

        var i, leap = 0, temp = 0;
        var baseDate = new Date(1900, 0, 31);
        var offset = (objDate - baseDate) / 86400000;

        this.dayCyl = offset + 40;
        this.monCyl = 14;

        for (i = 1900; i < 2050 && offset > 0; i++) {
            temp = lYearDays(i);
            offset -= temp;
            this.monCyl += 12;
        }

        if (offset < 0) {
            offset += temp;
            i--;
            this.monCyl -= 12;
        }

        this.year = i;
        this.yearCyl = i - 1864;
        leap = leapMonth(i);
        //闰哪个月
        this.isLeap = false;

        for (i = 1; i < 13 && offset > 0; i++) {
            //闰月
            if (leap > 0 && i == (leap + 1) && this.isLeap == false) {
                --i;
                this.isLeap = true;
                temp = leapDays(this.year);
            } else {
                temp = monthDays(this.year, i);
            }

            //解除闰月
            if (this.isLeap == true && i == (leap + 1))
                this.isLeap = false;
            offset -= temp;
            if (this.isLeap == false)
                this.monCyl++;
        }

        if (offset == 0 && leap > 0 && i == leap + 1)
            if (this.isLeap) {
                this.isLeap = false;
            } else {
                this.isLeap = true;
                --i;
                --this.monCyl;
            }

        if (offset < 0) {
            offset += temp;
            --i;
            --this.monCyl;
        }

        this.month = i;
        this.day = offset + 1;
    }

    //如果当前是12月份，获取下一年的节假日，没有获取到数据，还是显示当前年的
    currMoth + 1 === 12 && currYear++;

    function getJsonLength(jsonData) {
        var length = 0;
        for(var ever in jsonData) {
            length++;
        }
        return length;
    }
    //获取当前年的节假日数据 【以下使用接口已停用  当前暂不提供显示 休 与 班 的功能】
    function getHolidayDates(year) {
        var arrParam = [];
        arrParam.push((year-1).toString()+'12');//将上一年12月份的放假内容也查询出来，因为元旦放假可能是在上一年12份的最后2天
        for (var i = 1; i <= 12; i++) {
            var month = i.toString().length === 1 ? '0' + i : i;
            arrParam.push(year.toString() + month.toString());
        }

        $.ajax({
            url: 'http://www.easybots.cn/api/holiday.php?m=' + arrParam.join(','),
            dataType: 'json'
        }).then(function (data) {
            if(getJsonLength(data)!=13){//如果当前是12月份，获取下一年的节假日，没有获取到数据，currYear--还是显示当前年的
                currYear--;
                getHolidayDates(currYear);
            }
            else{
                holidayDates = data;
            }
        });
    }
    //初始化页面 时，就先将 数据请求过来，点开日历时，便可直接用
    // getHolidayDates(currYear);
    /*-------------有关免费节假日接口服务 详情请查看：https://www.jianshu.com/p/99931a7a4f0d----------------*/

    return setHoliday;
};



//////////////////
// WEBPACK FOOTER
// ./src/plugins/wdatePicker/holidayCalendar.js
// module id = 201
// module chunks = 0